<template>
  <div>
    <PageTitleVue :sub-title="'Cadastre um novo estudante'">
      Cadastrar aluno

      <!-- go back -->
      <template #b-action>
        <Create
          @click="router.push('/fighters')"
          :icon="PhArrowLeft"
          :label="'Voltar'"
          :menu-active="'Lutadores'"
        />
      </template>
    </PageTitleVue>

    <Form
      id="form-fields"
      :descriptionTitle="'Dados pessoais'"
      :isCreate="true"
    >
      <Password
        v-if="!isBatchImport"
        :create="true"
        :descriptionTitle="'Senha de acesso'"
        :descriptionSubTitle="'Defina uma senha de acesso para o aluno'"
      />

      <div v-else class="bg-blue-50 border border-blue-200 rounded-md p-4 text-sm text-blue-800">
        Importação em lote ativa. Usuário e senha poderão ser gerados automaticamente no back-end a partir dos dados da planilha.
      </div>

      <div class="w-full flex justify-center mt-4">
        <CreateButton
          @click="newCollaborator"
          :icon="batchButtonIcon"
          :label="submitLabel"
        />
      </div>
    </Form>

    <!-- <FloatBackPage /> -->
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import CollabService from '../services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import FloatBackPage from '@/components/Buttons/FloatBackPage.vue'
import PermissionsForm from './PermissionsForm.vue'
import ShiftForm from './ShiftForm.vue'
import Password from './PasswordForm.vue'
import Form from './Form.vue'
import * as yup from '@/validator'
import { dataFighters } from '../store'
import { storeApp } from '@/store'
import {
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { onBeforeMount, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import router from '@/router'
import { PhArrowLeft } from '@phosphor-icons/vue'

import {
  permissionsUser,
  permissionsManager,
  permissionsSub
} from '../lookups/permissions'

const appStore = storeApp
const store = dataFighters

const isBatchImport = computed(() => store.state.importUsers.length > 0)
const submitLabel = computed(() => isBatchImport.value ? 'Importar alunos' : 'Adicionar')
const batchButtonIcon = computed(() => isBatchImport.value ? 'fa-solid fa-file-import' : 'fa-solid fa-user-plus')

const form = yup.object().shape({
  name: yup.string().required().label('Nome').min(3).max(100),
  email: yup.string().required().label('Usuário').max(100),
  password: yup.object().shape({
    newPass: yup
      .string()
      .required('É necessário informar a nova senha')
      .min(5, 'Deve ter no mínimo 5 caracteres'),
    confirm: yup
      .string()
      .oneOf([yup.ref('newPass'), null], 'As senhas devem ser iguais')
      .required('Por favor confirme a nova senha')
  })
})

onBeforeMount(async () => {
  appStore.state.loading = true
  store.commit('reset')
  await events()
  appStore.state.loading = false
})

// busca todos os eventos
async function events () {
  await CollabService.getEvents()
    .then((res) => {
      store.dispatch('setComboEvents', res.data)
    })
    .catch((err) => {
      toast('Aviso', 'Algo deu arrado ao buscar eventos', 'error')
    })
}

// registra um novo colaborador
async function newCollaborator () {
  appStore.state.loading = true

  if (isBatchImport.value) {
    return registerBatchCollaborators()
  }

  // validação dos campos de formulário
  const validate = await validateFormField(form, store.state)
  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.state.loading = false

    toast('Aviso', 'Campos obrigatórios não preenchidos', 'error')

    return
  }

  const data = buildSinglePayload()

  await CollabService.register(data)
    .then((res) => {
      appStore.state.loading = false
      if (res.data.success) {
        toast('Sucesso', res.data.message, 'success')
        store.commit('reset')
      }
    })
    .catch((err) => {
      appStore.state.loading = false

      if (err.response?.status && err.response.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      toast('Erro', err.response?.data?.error || 'Erro ao cadastrar colaborador.', 'error')
    })
}

async function registerBatchCollaborators () {
  if (!store.state.importUsers.length) {
    appStore.state.loading = false
    return toast('Aviso', 'Nenhum colaborador foi carregado para importação.', 'error')
  }

  const payload = buildBatchPayload()

  await CollabService.register(payload)
    .then((res) => {
      appStore.state.loading = false

      if (res.data.success) {
        toast('Sucesso', res.data.message, 'success')
        store.commit('reset')
      }
    })
    .catch((err) => {
      appStore.state.loading = false

      if (err.response?.status && err.response.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      toast('Erro', err.response?.data?.error || 'Erro ao importar colaboradores.', 'error')
    })
}

function buildSinglePayload () {
  const data = Object.assign({}, store.state)

  delete data.password.confirm
  delete data.password.old
  data.password = data.password.newPass

  delete data.turno
  delete data.fighters
  delete data.events
  delete data.myEvents
  delete data.importUsers
  delete data.importFileName
  delete data.importErrors
  delete data.image
  delete data.imgPath

  return data
}

function buildBatchPayload () {
  return {
    importType: 'spreadsheet',
    users: store.state.importUsers.map((user) => ({
      name: user.name,
      cpf: user.cpf,
      role: user.role
    }))
  }
}
</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
